<template>
  <div>
      <div slot="titulo">
        <i class="fas fa-users-cog icon"></i>
        Encuesta satisfacción usuario
      </div>

      <div slot="contenido">
        <ShowQuestionary
          v-if="isComponentModalActive"
          :isComponentModalActive="isComponentModalActive"
          :questionarie_id="questionarie_id"
          :closeBasic="closeBasic"
          :chargeQuestionarieList="chargeQuestionarieList"
        ></ShowQuestionary>
        <div class="box">
          <b-table
            type="is-primary"
            :data.sync="listQuestionarie"
            :loading="loading"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :default-sort-direction="defaultSortDirection"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :is-fullwidth="true"
            default-sort="stablishment.name"
            aria-next-label="Next page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
                            <b-table-column field="name" label="Nombre">{{ props.row.questionary.name }}</b-table-column>

              <b-table-column
                field="description"
                label="Descripción"
                v-html="props.row.questionary.description"
              ></b-table-column>
              <b-table-column
                field="state"
                label="Estado de Cuestionario"
              >
              <span class="tag is-success" v-if="props.row.questionary.state=='Abierta'">
                    {{ props.row.questionary.state }}
                </span>
                <span class="tag is-danger"  v-if="props.row.questionary.state=='Cerrada'">
                    {{ props.row.questionary.state }}
                </span>
                <span class="tag is-info"  v-if="props.row.questionary.state=='Creada'">
                    {{ props.row.questionary.state }}
                </span>            
              </b-table-column>
              <b-table-column
                field="date_start"
                label="Inicio"
              >{{ props.row.questionary.date_start }}</b-table-column>
              <b-table-column field="date_end" label="Fin">{{ props.row.questionary.date_end }}</b-table-column>
              <b-table-column label="Acciones">
                <div
                  v-if="props.row.questionary.state=='Abierta'"
                >
                  <b-button
                    type="is-info is-small"
                    @click="openBasic(props.row.questionary.id)"
                  >Abrir Encuesta</b-button>
                </div>
                <!-- <div v-else-if="props.row.questionary.users_questionaries.length!=0">
                  Encuesta ya Respondida
                </div> -->
                <div v-else>
                  Encuesta No Disponible
                </div>
              </b-table-column>
            </template>
          </b-table>
        </div>
      </div>

  </div>
</template>
<script>
import ShowQuestionary from "../../../components/functionary/showQuestionary";
import { getQuestionariePublic } from "../../../services/questionarie";

export default {
  components: {
    ShowQuestionary,
  },
  data() {
    return {
      questionarie_id: null,
      listQuestionarie: [],
      isFullPage: true,
      isComponentModalActive: false,
      isPaginated: true,
      loading: false,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 5,
    };
  },
  mounted: function () {
    this.chargeQuestionarieList();
  },
  methods: {
    async openBasic(id) {
      let loader = this.$buefy.loading.open();
      this.questionarie_id = id;
      await getQuestionariePublic(this.$http, id).then((response) => {
        loader.close();
        console.log("Tiene Term?", response.term_required);
        if (response.term_required == 1) {
          //  var parser = new DOMParser();
          // var doc = parser.parseFromString(response.term.message, "text/html");
          this.$buefy.dialog.confirm({
            title: response.term.title,
            message: response.term.message,
            cancelText: "No Acepto",
            confirmText: "Acepto",
            type: "is-success",
            onConfirm: () => (this.isComponentModalActive = true),
          });
        } else {
          this.isComponentModalActive = true;
        }
      });
    },
    closeBasic() {
      this.questionarie_id = null;
      this.isComponentModalActive = false;
    },
    chargeQuestionarieList() {
      this.loading = true;
      this.listQuestionarie = [];
      this.$http
        .get(
          `api/questionary_location/find_by_stablishment_and_stament_id_public/3/Abierta/1`
        )
        .then(
          (response) => {
            this.listQuestionarie = response.body.questionary;
            console.log(this.listQuestionarie)
            this.loading = false;
          },
          (response) => {
            console.log("error: ", response);
          }
        );
    },
  },
};
</script>

